import type { TenantLogEntry, TenantLogKind } from "@lumora/bridge";

export type LogsKindFilter = "all" | TenantLogKind;

export const LOGS_PAGE_SIZE = 50;

export interface LogsRow {
  id: string;
  when: string;
  kind: string;
  method: string;
  path: string;
  status: string;
  detail: string;
}

/** Drops the query string/fragment so tokens or codes in URLs are never rendered. */
export function safePath(path: string | undefined): string {
  if (!path) return "";
  const cut = path.search(/[?#]/);
  return cut === -1 ? path : path.slice(0, cut);
}

export function logsRow(e: TenantLogEntry): LogsRow {
  const t = new Date(e.at);
  return {
    id: e.id,
    when: Number.isNaN(t.getTime()) ? e.at : t.toLocaleString(),
    kind: e.kind,
    method: e.method ?? "",
    path: safePath(e.path),
    status: e.status !== undefined ? String(e.status) : "",
    detail: e.kind === "event" ? (e.message ?? e.actor ?? "") : (e.actor ?? e.message ?? ""),
  };
}

/** Append a page, de-duplicating by id (a cursor overlap must not double-render rows). */
export function appendEntries(prev: TenantLogEntry[], next: TenantLogEntry[]): TenantLogEntry[] {
  const seen = new Set(prev.map((e) => e.id));
  return [...prev, ...next.filter((e) => !seen.has(e.id))];
}

/** Owners hold logs:read; mirror the server role gate client-side (server stays authoritative). */
export function canViewLogs(role: string | null | undefined): boolean {
  return role === "owner";
}
